import React from 'react';
import PropTypes from 'prop-types';
import { Button, Space, Table } from 'antd';
import { EditTwoTone, DeleteTwoTone } from '@ant-design/icons';

import { YuhuModules, Triggers, Actions, CalculationTypes, PercentCalc } from '../Form/constants';

const FeeEventsTable = ({ dataSource }) => {
  const columns = [
    {
      title: 'Module',
      dataIndex: 'yuhu_module',
      render: (text) => YuhuModules[text],
    },
    {
      title: 'Trigger',
      dataIndex: 'trigger',
      render: (text) => Triggers[text],
    },
    {
      title: 'Action',
      dataIndex: 'action',
      render: (text) => Actions[text],
    },
    {
      title: 'Calculation',
      dataIndex: 'calculation_type',
      render: (text) => CalculationTypes[text],
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      render: (_, rowData) => {
        if (rowData.calculation_type === PercentCalc) return `${rowData.percent_value}%`;
        return `$${rowData.amount_value}`;
      },
    },
    {
      title: 'Actions',
      dataIndex: 'actions',
      render: (_, rowData) => {
        return (
          <Space size="small">
            <Button shape="circle" type="text" icon={<EditTwoTone />} onClick={rowData.onEdit} />
            <Button
              shape="circle"
              type="text"
              icon={<DeleteTwoTone />}
              onClick={rowData.onDelete}
            />
          </Space>
        );
      },
    },
  ];

  return (
    <>
      {dataSource.length > 0 && (
        <Table
          size="small"
          bordered
          columns={columns}
          dataSource={dataSource}
          pagination={{
            hideOnSinglePage: true,
            size: 'small',
          }}
        ></Table>
      )}
    </>
  );
};

FeeEventsTable.propTypes = {
  dataSource: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default FeeEventsTable;
